import { BancoModel } from "./banco.model";

export class ContaCorrenteModel {
  id?: number;
  bancoId?: number;
  cnpjEmpresa?: string;
  descricao?: string;
  agencia?: string;
  conta?: string;
  clientId?: string;
  usuarioIntegracao?: string;
  senhaIntegracao?: string;
  saldoInicial?: number;
  saldo?: number;
  sandBox?: boolean;
  marketPlace?: boolean;
  ativo?: boolean;
  sindicato?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  banco?: BancoModel;

  constructor(options: ContaCorrenteModel = {}) {
    this.id = options.id || null;
    this.bancoId = options.bancoId || null;
    this.cnpjEmpresa = options.cnpjEmpresa || null;
    this.descricao = options.descricao || null;
    this.agencia = options.agencia || null;
    this.conta = options.conta || null;
    this.clientId = options.clientId || null;
    this.usuarioIntegracao = options.usuarioIntegracao || null;
    this.senhaIntegracao = options.senhaIntegracao || null;
    this.saldoInicial = options.saldoInicial || null;
    this.saldo = options.saldo || null;
    this.sandBox = options.sandBox || null;
    this.marketPlace = options.marketPlace || null;
    this.ativo = options.ativo || null;
    this.sindicato = options.sindicato || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.banco = options.banco || new BancoModel();
  }
}
